/* tslint:disable */
/* eslint-disable */
/**
 * ファイル管理ポータル クライアントAPI
 * ファイル管理ポータル Webクライアント向けAPI 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: TODO@graat.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { PositionModel } from './position-model';
// May contain unused imports in some cases
// @ts-ignore
import { ServiceProjectPolicy } from './service-project-policy';
// May contain unused imports in some cases
// @ts-ignore
import { ServiceProjectPolicyResponse } from './service-project-policy-response';
// May contain unused imports in some cases
// @ts-ignore
import { ServiceProjectStatus } from './service-project-status';
// May contain unused imports in some cases
// @ts-ignore
import { ServiceProjectStatusResponse } from './service-project-status-response';

/**
 * 
 * @export
 * @interface ProjectResponseAllOf
 */
export interface ProjectResponseAllOf {
    /**
     * プロジェクトID
     * @type {string}
     * @memberof ProjectResponseAllOf
     */
    'project_id'?: string;
    /**
     * 事業種別コード
     * @type {string}
     * @memberof ProjectResponseAllOf
     */
    'business_type_code'?: string;
    /**
     * テンプレートとなるプロジェクトかを示すフラグ<br> テンプレートプロジェクトは、オーナー企業別・本支店別・プロジェクト種別毎に１つ存在する - 実プロジェクト：PROJECT - テンプレート：TEMPLATE 
     * @type {string}
     * @memberof ProjectResponseAllOf
     */
    'template_frag'?: ProjectResponseAllOfTemplateFragEnum;
    /**
     * このAPIを実行したユーザが管理者の役務を持つかを示すフラグ <br> 管理者でないと、ユーザは管理者の機能が使えない - 管理者以外：NONADMIN - 管理者：ADMIN 
     * @type {string}
     * @memberof ProjectResponseAllOf
     */
    'admin_frag'?: ProjectResponseAllOfAdminFragEnum;
    /**
     * プロジェクト種別コード
     * @type {string}
     * @memberof ProjectResponseAllOf
     */
    'project_type_code'?: string;
    /**
     * オーナー企業ID
     * @type {string}
     * @memberof ProjectResponseAllOf
     */
    'owner_company_id'?: string;
    /**
     * 本支店オブジェクトID
     * @type {string}
     * @memberof ProjectResponseAllOf
     */
    'branch_object_id'?: string;
    /**
     * 
     * @type {ServiceProjectStatus}
     * @memberof ProjectResponseAllOf
     * @deprecated
     */
    'service_project_status_fp'?: ServiceProjectStatus | null;
    /**
     * 
     * @type {ServiceProjectPolicy}
     * @memberof ProjectResponseAllOf
     * @deprecated
     */
    'service_project_policy_fp'?: ServiceProjectPolicy;
    /**
     * 
     * @type {ServiceProjectStatus}
     * @memberof ProjectResponseAllOf
     * @deprecated
     */
    'service_project_status_ddms'?: ServiceProjectStatus | null;
    /**
     * 
     * @type {ServiceProjectPolicy}
     * @memberof ProjectResponseAllOf
     * @deprecated
     */
    'service_project_policy_ddms'?: ServiceProjectPolicy;
    /**
     * 
     * @type {ServiceProjectStatus}
     * @memberof ProjectResponseAllOf
     * @deprecated
     */
    'service_project_status_photo'?: ServiceProjectStatus | null;
    /**
     * 
     * @type {ServiceProjectPolicy}
     * @memberof ProjectResponseAllOf
     * @deprecated
     */
    'service_project_policy_photo'?: ServiceProjectPolicy;
    /**
     * 
     * @type {Array<ServiceProjectStatusResponse>}
     * @memberof ProjectResponseAllOf
     */
    'service_project_statuses'?: Array<ServiceProjectStatusResponse>;
    /**
     * 
     * @type {Array<ServiceProjectPolicyResponse>}
     * @memberof ProjectResponseAllOf
     */
    'service_project_policies'?: Array<ServiceProjectPolicyResponse>;
    /**
     * 立場一覧
     * @type {Array<PositionModel>}
     * @memberof ProjectResponseAllOf
     */
    'positions'?: Array<PositionModel>;
}

export const ProjectResponseAllOfTemplateFragEnum = {
    Project: 'PROJECT',
    Template: 'TEMPLATE'
} as const;

export type ProjectResponseAllOfTemplateFragEnum = typeof ProjectResponseAllOfTemplateFragEnum[keyof typeof ProjectResponseAllOfTemplateFragEnum];
export const ProjectResponseAllOfAdminFragEnum = {
    Admin: 'ADMIN',
    Nonadmin: 'NONADMIN'
} as const;

export type ProjectResponseAllOfAdminFragEnum = typeof ProjectResponseAllOfAdminFragEnum[keyof typeof ProjectResponseAllOfAdminFragEnum];


